(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('#aboutAccordion .accordion-button');
    const image = document.getElementById('accordion-image');

    accordionButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const newImage = this.getAttribute('data-image');

        if (newImage && image.src !== newImage) {
          // Oculta com transição para a esquerda
          image.classList.remove('show');

          setTimeout(() => {
            image.src = newImage;

            // Força reflow
            void image.offsetWidth;

            // Exibe com animação
            image.classList.add('show');
          }, 400); // tempo da transição
        }
      });
    });

    // Exibe a imagem inicial com animação
    image.classList.add('show');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["also-may-like-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initSwiperWhenReady() {
      const swiperEl = document.querySelector('.recommended-swiper');
      const slides = swiperEl?.querySelectorAll('.swiper-slide') || [];

      if (!swiperEl || slides.length < 2) {
        setTimeout(initSwiperWhenReady, 100);
        return;
      }

      if (swiperEl.classList.contains('swiper-initialized')) return;

      new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      });

      swiperEl.classList.add('swiper-initialized');
    }

    initSwiperWhenReady();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champagne-makers-automatic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.blog-swiper', {
      loop: false,
      spaceBetween: 64,
      slidesPerView: 3,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 56,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 45,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champagne-makers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.blog-swiper', {
      loop: false,
      spaceBetween: 64,
      slidesPerView: 3,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 56,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 45,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champagnes-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.champagneSwiper', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      spaceBetween: 32,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 5,
          centeredSlides: true,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-questions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.faq-tabs .nav-link');
    const select = document.querySelector('.faq-select');
    const contents = document.querySelectorAll('.faq-category-content');

    function showCategory(cat) {
      contents.forEach((c) => {
        c.style.display = c.getAttribute('data-category') === cat ? 'block' : 'none';
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        const cat = tab.getAttribute('data-category');
        showCategory(cat);
        if (select) select.value = cat;
      });
    });

    if (select) {
      select.addEventListener('change', (e) => {
        const cat = e.target.value;
        showCategory(cat);
        tabs.forEach((t) => {
          t.classList.toggle('active', t.getAttribute('data-category') === cat);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const onlyChampsNewsletterPage = document.querySelector('[data-onlychamps-newsletter-page="true"]');

    if (urlParams.get('customer_posted') === 'true') {
      if (onlyChampsNewsletterPage) {
        return;
      }

      const modal = new bootstrap.Modal(document.getElementById('newsletterSuccessModal'));
      modal.show();

      localStorage.setItem('userSubscribed', 'true');

      const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  });

  document.querySelectorAll('.logo-footer').forEach((logo) => {
    logo.addEventListener('mouseenter', () => {
      logo.querySelectorAll('i').forEach((i) => {
        const x = Math.random() * 200 - 100 + 'px';
        const y = Math.random() * 200 - 100 + 'px';
        const r = Math.random() * 360 + 'deg';
        const h = Math.floor(Math.random() * 360);
        i.style.setProperty('--x', x);
        i.style.setProperty('--y', y);
        i.style.setProperty('--r', r);
        i.style.backgroundColor = `hsl(${h}, 100%, 50%)`;
        i.style.animation = 'bang 700ms ease-out forwards';
      });
    });

    logo.addEventListener('mouseleave', () => {
      logo.querySelectorAll('i').forEach((i) => {
        i.style.animation = 'none';
        i.offsetHeight;
        i.style.opacity = 0;
      });
    });
  });

  window.copyCoupon = function () {
    var coupon = document.getElementById('couponCode');
    var range = document.createRange();
    range.selectNode(coupon);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        var copyMsg = document.getElementById('copyMessage');
        copyMsg.style.display = 'block';
        setTimeout(function () {
          copyMsg.style.display = 'none';
        }, 2000);
      } else {
        console.error('Copy command was unsuccessful');
      }
    } catch (err) {
      console.error('Oops, unable to copy', err);
    }

    window.getSelection().removeAllRanges();
  };

  document.querySelectorAll('.add-to-cart-link').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const cartPopup = new bootstrap.Modal(document.getElementById('cartPopup'));
          cartPopup.show();
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
        });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const champagneIcon = document.getElementById('champagneIcon');

    function hasSeenDiscountModal() {
      return sessionStorage.getItem('discountModalShown') === 'true';
    }

    function hasSubscribedToNewsletter() {
      return localStorage.getItem('userSubscribed') === 'true';
    }

    function shouldShowIcon() {
      var path = window.location.pathname;
      return /^\/products\/[^/]+$/.test(path) || /^\/collections\/[^/]+$/.test(path) || path === '/collections';
    }

    if (shouldShowIcon() && !hasSeenDiscountModal() && !hasSubscribedToNewsletter()) {
      champagneIcon.style.display = 'block';

      champagneIcon.addEventListener('click', function () {
        var discountModal = new bootstrap.Modal(document.getElementById('firstOrderDiscountModal'));
        discountModal.show();
        champagneIcon.style.display = 'none';
        sessionStorage.setItem('discountModalShown', 'true');
      });
    }

    if (!hasSeenDiscountModal() && !hasSubscribedToNewsletter()) {
      setTimeout(() => {
        const discountModal = new bootstrap.Modal(document.getElementById('firstOrderDiscountModal'));
        discountModal.show();
        sessionStorage.setItem('discountModalShown', 'true');
      }, 5000);
    }

    function triggerBounce() {
      champagneIcon.style.animation = 'anime-bounce 1s ease';
      setTimeout(() => {
        champagneIcon.style.animation = '';
      }, 1000);
    }

    setInterval(triggerBounce, 20000);
    triggerBounce();
  });

  document.querySelector('.close-and-refresh')?.addEventListener('click', function (e) {
    e.preventDefault();
    const modal = bootstrap.Modal.getInstance(document.getElementById('cartPopup'));
    modal.hide();
    setTimeout(() => {
      location.reload();
    }, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const icon = document.getElementById('champagneIcon');

    function triggerBounce() {
      icon.style.animation = 'anime-bounce 1s ease';

      setTimeout(() => {
        icon.style.animation = '';
      }, 1000);
    }

    setInterval(triggerBounce, 20000);

    triggerBounce();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onResize = () => this.setHeaderHeight();

      this.setHeaderHeight();

      this.headerBreakpoint = window.matchMedia('(max-width: 990px)');
      this.headerBreakpoint.addEventListener('change', this.onResize);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', this.onResize);

      if (window.ResizeObserver) {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.header.classList.add('scrolled-past-header');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onResize);

      if (this.headerBreakpoint) {
        this.headerBreakpoint.removeEventListener('change', this.onResize);
      }

      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('scrolled-past-header');

    const pageInfoEl = document.getElementById('page-info');
    let isHome = false;

    if (pageInfoEl) {
      try {
        const data = JSON.parse(pageInfoEl.textContent);
        isHome = data.isHome === true;
      } catch (e) {
        console.error('Invalid page-info JSON', e);
      }
    }

    const logoMobile = document.querySelector('.logo-mobile');
    const logoDefault = document.querySelector('.logo-desktop-default');
    const logoOther = document.querySelector('.logo-desktop-other');

    if (!logoMobile || !logoDefault || !logoOther) return;

    const mqMobile = window.matchMedia('(max-width: 989px)');

    function hideAll() {
      logoMobile.style.display = 'none';
      logoDefault.style.display = 'none';
      logoOther.style.display = 'none';
    }

    function updateLogos() {
      const isMobile = mqMobile.matches;
      const scrolled = true;

      hideAll();

      if (isMobile) {
        logoMobile.style.display = 'inline-block';
        return;
      }

      if (!isHome) {
        logoOther.style.display = 'inline-block';
        return;
      }

      if (scrolled) {
        logoOther.style.display = 'inline-block';
      } else {
        logoDefault.style.display = 'inline-block';
      }
    }

    updateLogos();

    window.addEventListener('scroll', updateLogos);
    window.addEventListener('resize', updateLogos);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ambrosia"] && !Shopify.designMode) return;
  try {
    
  window.requestAnimationFrame(() => {
    new Swiper('.heroSwiper', {
      loop: false,
      spaceBetween: 2,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-champagnemakers-ambrosia"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const gallery = document.querySelector('.champagne-gallery2 .row');
    if (!gallery) return;

    const allItems = gallery.querySelectorAll('.col-6');
    if (allItems.length < 5) return;

    const firstImage = allItems[0];
    const rightContainer = document.createElement('div');
    rightContainer.className = 'col-6 d-flex flex-wrap gap-2';

    for (let i = 1; i <= 4; i++) {
      const el = allItems[i];
      el.style.width = 'calc(50% - 4px)';
      rightContainer.appendChild(el);
    }

    gallery.innerHTML = '';
    gallery.appendChild(firstImage);
    gallery.appendChild(rightContainer);
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      new Swiper('.gallery-swiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.partners-swiper', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      spaceBetween: 30,
      slidesPerView: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quantity-wrapper').forEach((wrapper) => {
      const input = wrapper.querySelector('input[name="quantity"]');
      const btnMinus = wrapper.querySelector('.qty-btn.minus');
      const btnPlus = wrapper.querySelector('.qty-btn.plus');

      btnMinus.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, current - 1);
      });

      btnPlus.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        input.value = current + 1;
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('galleryModal');
    const modalBody = modal.querySelector('.modal-body');
    const images = Array.from(document.querySelectorAll('.gallery-image'));
    let currentIndex = 0;

    function getVideoMimeType(url) {
      const ext = url.split('.').pop().toLowerCase();
      switch (ext) {
        case 'mp4':
          return 'video/mp4';
        case 'webm':
          return 'video/webm';
        case 'mov':
          return 'video/quicktime';
        default:
          return 'video/mp4';
      }
    }

    function resetModalBody() {
      modalBody.innerHTML = `
      <button
        type="button"
        class="btn-close position-absolute top-0 end-0 m-3"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
      <button
        class="btn btn-light position-absolute start-0 top-50 translate-middle-y gallery-prev"
        style="z-index:10;"
      >
        ‹
      </button>
      <button
        class="btn btn-light position-absolute end-0 top-50 translate-middle-y gallery-next"
        style="z-index:10;"
      >
        ›
      </button>
    `;
    }

    function showMedia(index) {
      if (index < 0 || index >= images.length) return;
      currentIndex = index;

      const el = images[index];
      const type = el.dataset.type || 'image';
      const src = el.dataset.src || el.src;
      const poster = el.dataset.poster || '';
      let html = '';

      if (type === 'video') {
        const mime = getVideoMimeType(src);
        html = `
      <video class="w-100 rounded" controls autoplay playsinline poster="${poster}">
        <source src="${src}" type="${mime}">
        Your browser does not support the video tag.
      </video>
    `;
      } else if (type === 'youtube') {
        html = `
      <div class="ratio ratio-16x9">
        <iframe src="${src}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    `;
      } else {
        html = `<img src="${src}" class="img-fluid rounded">`;
      }

      resetModalBody();
      modalBody.insertAdjacentHTML('afterbegin', html);

      modalBody.querySelector('.gallery-prev').addEventListener('click', () => {
        showMedia((currentIndex - 1 + images.length) % images.length);
      });

      modalBody.querySelector('.gallery-next').addEventListener('click', () => {
        showMedia((currentIndex + 1) % images.length);
      });

      bootstrap.Modal.getOrCreateInstance(modal).show();
    }

    images.forEach((img, i) => {
      img.addEventListener('click', () => showMedia(i));
    });

    document.querySelector('.gallery-prev')?.addEventListener('click', () => {
      showMedia((currentIndex - 1 + images.length) % images.length);
    });

    document.querySelector('.gallery-next')?.addEventListener('click', () => {
      showMedia((currentIndex + 1) % images.length);
    });

    modal.addEventListener('hidden.bs.modal', resetModalBody);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const copyBtn = document.querySelector('.copy-link');

    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
          copyBtn.classList.add('copied');
          setTimeout(() => copyBtn.classList.remove('copied'), 2000);
        });
      });
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    const copyBtn = document.querySelector('.copy-link');
    const copiedMsg = document.querySelector('.copied-msg');

    if (copyBtn && copiedMsg) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
          copiedMsg.classList.add('show');

          setTimeout(() => {
            copiedMsg.classList.remove('show');
          }, 1500);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-per-champagnemaker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.champagneSwiper', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      spaceBetween: 32,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 5,
          centeredSlides: true,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-blog-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      new Swiper('.blog-news-swiper-single', {
        loop: true,
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.video-wrapper').forEach((wrapper) => {
      wrapper.querySelector('.play-button').addEventListener('click', function () {
        const videoUrl = wrapper.dataset.youtube;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', videoUrl + '?autoplay=1&rel=0');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('allow', 'autoplay');
        iframe.classList.add('w-100', 'h-100');
        wrapper.innerHTML = '';
        wrapper.appendChild(iframe);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-blog-section-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const copyBtn = document.querySelector('.copy-link');

    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
          copyBtn.classList.add('copied');
          setTimeout(() => copyBtn.classList.remove('copied'), 2000);
        });
      });
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    const copyBtn = document.querySelector('.copy-link');
    const copiedMsg = document.querySelector('.copied-msg');

    if (copyBtn && copiedMsg) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
          copiedMsg.classList.add('show');

          setTimeout(() => {
            copiedMsg.classList.remove('show');
          }, 1500);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-ambrosia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      new Swiper('.blog-news-swiper', {
        loop: true,
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
